export const isChromeBrowser = (): boolean => {
  return navigator?.userAgent?.toString().includes('Chrome/') && navigator?.vendor?.includes('Google Inc.') && !navigator?.userAgent?.toString().includes('Edg/');
};
